/* Heart Magic homepage — shared bootstrapping.
   Loaded (deferred, idempotent) by every hm-* section via snippets/hm-base.liquid,
   so the page never depends on any single section being present. */
(function () {
  if (window.__hmReveal) return;
  window.__hmReveal = true;
  var init = function () {
    var els = document.querySelectorAll('.hm-reveal');
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('hm-in'); });
      return;
    }
    /* 2026-09-13: thresholds are [0, 0.12], not 0.12 alone. An element taller
       than the viewport can never show 12% of itself at once, so a tall block
       could sit at opacity 0 forever - which is what "whole sections render as
       empty gradient blocks" looks like. Normal blocks still wait for 12%; only
       ones taller than 70% of the viewport reveal on first contact. */
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        var tall = e.boundingClientRect.height > window.innerHeight * 0.7;
        if (!tall && e.intersectionRatio < 0.12) return;
        e.target.classList.add('hm-in');
        io.unobserve(e.target);
      });
    }, { threshold: [0, 0.12] });
    els.forEach(function (el) { io.observe(el); });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
